<template>
    <div>
        <s-crud
            title="Historial de movimiento"
            :config="config"
            :filter="filter"
            ref="crudProductMovement"
            @save="save($event)"
            @EditEvent="onEditEvent($event)"
            @addEvent="onAddEvent()"
            @delete="deleteItem($event)"
            @rowSelected="onRowSelected($event)"
            add
            :edit="!isCurrentRowExecuted"
            :remove="!isCurrentRowExecuted"
            deleteNoFunction
            singleRow
        >
            <template v-slot="props">
                <v-container v-if="props.item != null">
                    <v-row dense>
                        <!-- Origen -->
                        <v-col cols="12" lg="3" md="3" sm="6" class="s-col-form">
                            <s-select
                                label="Línea Origen"
                                v-model="selectedOriginLineID"
                                :items="activeLines"
                                item-value="ClpID"
                                item-text="LncDescription"
                                autocomplete
                                @change="onOriginLineChange($event, props.item)"
                                ref="txtOriginLine"
                            />
                        </v-col>
                        <v-col cols="12" lg="3" md="3" sm="6" class="s-col-form">
                            <s-select
                                label="Periodo Origen"
                                v-model="props.item.PchIDOrigin"
                                :items="originPeriods"
                                item-value="PchID"
                                item-text="PchPeriodo"
                                autocomplete
                                ref="txtPchIDOrigin"
                            />
                        </v-col>
                        
                        <!-- Destino -->
                        <v-col cols="12" lg="3" md="3" sm="6" class="s-col-form">
                            <s-select
                                label="Línea Destino"
                                v-model="selectedDestinyLineID"
                                :items="activeLines"
                                item-value="ClpID"
                                item-text="LncDescription"
                                autocomplete
                                @change="onDestinyLineChange($event, props.item)"
                                ref="txtDestinyLine"
                            />
                        </v-col>
                        <v-col cols="12" lg="3" md="3" sm="6" class="s-col-form">
                            <s-select
                                label="Periodo Destino"
                                v-model="props.item.PchIDDestiny"
                                :items="destinyPeriods"
                                item-value="PchID"
                                item-text="PchPeriodo"
                                autocomplete
                                ref="txtPchIDDestiny"
                            />
                        </v-col>

                        <!-- Motivo y Peso -->
                        <v-col cols="12" lg="6" md="6" sm="12" class="s-col-form">
                            <s-select-definition
                                label="Motivo"
                                v-model="props.item.TransferReasonID"
                                :def="1717"
                                add
                                ref="txtTransferReasonID"
                            />
                        </v-col>
                        <v-col cols="12" lg="6" md="6" sm="12" class="s-col-form">
                            <s-text
                                label="Peso movido (kg)"
                                v-model="props.item.TransferWeight"
                                decimal
                                ref="txtTransferWeight"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </template>

            <!-- Custom grid templates -->
            <template v-slot:Ejecutar="{ row }">
                <v-btn
                    x-small
                    :color="row.IsExecuted ? 'success' : 'primary'"
                    :disabled="row.IsExecuted"
                    @click="executeMovement(row)"
                >
                    <v-icon left x-small v-if="row.IsExecuted">mdi-check</v-icon>
                    {{ row.IsExecuted ? 'Ejecutado' : 'Ejecutar' }}
                </v-btn>
            </template>
        </s-crud>
    </div>
</template>

<script>
import _sFrzLinesTransferHistory from "@/services/FrozenProduction/FrzLinesTransferHistory.js";
import _sFrzCtnLinesProcessService from "@/services/FrozenProduction/FrzCtnLinesProcess.js";
import _sTurnService from "@/services/FreshProduction/PrfTurnService.js";

export default {
    data() {
        return {
            activeLines: [],
            originPeriods: [],
            destinyPeriods: [],
            allPeriodsMap: [],
            activeTurnId: null,
            activeTypeCultive: null,
            selectedOriginLineID: null,
            selectedDestinyLineID: null,
            isSaving: false,
            isCurrentRowExecuted: false,
            config: {
                model: {
                    LthID: "ID",
                    OriginLineName: "string",
                    OriginPeriodName: "string",
                    DestinyLineName: "string",
                    DestinyPeriodName: "string",
                    TransferReasonName: "string",
                    TransferWeight: "decimal",
                    IsExecuted: "boolean",
                },
                service: _sFrzLinesTransferHistory,
                headers: [
                    { text: "Id", value: "LthID", width: "10%" },
                    { text: "Línea Origen", value: "OriginLineName" },
                    { text: "Periodo Origen", value: "OriginPeriodName" },
                    { text: "Motivo", value: "TransferReasonName" },
                    { text: "Línea Destino", value: "DestinyLineName" },
                    { text: "Periodo Destino", value: "DestinyPeriodName" },
                    { text: "Peso movido (kg)", value: "TransferWeight", align: "end" },
                    { text: "Ejecutar", value: "Ejecutar", align: "center", sortable: false },
                ]
            },
            filter: {
                PchIDOrigin: 0,
                TrnID: null,
                TurnID: null,
            }
        };
    },
    created() {
        this.loadActiveLinesAndMap();
    },
    methods: {
        async loadActiveLinesAndMap() {
            try {
                const turnResp = await _sTurnService.turnActive({ TypeArea: 4 }, this.$fun.getUserID());
                if (turnResp.status === 200 && turnResp.data.length > 0) {
                    const turnId = turnResp.data[0].TrnID;
                    this.activeTurnId = turnId;
                    this.filter.TrnID = turnId;
                    this.filter.TurnID = turnId;
                    if (this.$refs.crudProductMovement) {
                        this.$refs.crudProductMovement.refresh();
                    }

                    const crops = [1, 2, 3, 4, 5, 6];
                    for (const crop of crops) {
                        const resp = await _sFrzCtnLinesProcessService.listLineas({ TrnID: turnId, TypeCultive: crop }, this.$fun.getUserID());
                        if (resp.status === 200 && resp.data.length > 0) {
                            this.activeTypeCultive = crop;
                            this.activeLines = resp.data;
                            break;
                        }
                    }

                    if (this.activeLines.length > 0) {
                        const promises = this.activeLines.map(line =>
                            _sFrzCtnLinesProcessService.listConfHours({ ClpID: line.ClpID }, this.$fun.getUserID())
                        );
                        const responses = await Promise.all(promises);
                        const allPeriods = [];
                        responses.forEach((resp, index) => {
                            if (resp.status === 200) {
                                const clpId = this.activeLines[index].ClpID;
                                resp.data.forEach(p => {
                                    allPeriods.push({
                                        PchID: p.PchID,
                                        ClpID: clpId,
                                        PchPeriodo: p.PchPeriodo
                                    });
                                });
                            }
                        });
                        this.allPeriodsMap = allPeriods;
                    }
                }
            } catch (e) {
                console.error("Error loading active lines and mapping:", e);
            }
        },
        async onOriginLineChange(clpId, item) {
            item.PchIDOrigin = null;
            this.originPeriods = [];
            if (!clpId) return;
            try {
                const resp = await _sFrzCtnLinesProcessService.listConfHours({ ClpID: clpId }, this.$fun.getUserID());
                if (resp.status === 200) {
                    this.originPeriods = resp.data;
                }
            } catch (e) {
                console.error("Error fetching origin periods:", e);
            }
        },
        async onDestinyLineChange(clpId, item) {
            item.PchIDDestiny = null;
            this.destinyPeriods = [];
            if (!clpId) return;
            try {
                const resp = await _sFrzCtnLinesProcessService.listConfHours({ ClpID: clpId }, this.$fun.getUserID());
                if (resp.status === 200) {
                    this.destinyPeriods = resp.data;
                }
            } catch (e) {
                console.error("Error fetching destiny periods:", e);
            }
        },
        async save(item) {
            if (!item.PchIDOrigin) {
                this.$fun.alert("Seleccione el periodo de origen", "warning");
                return;
            }
            if (!item.PchIDDestiny) {
                this.$fun.alert("Seleccione el periodo de destino", "warning");
                return;
            }
            if (item.PchIDOrigin === item.PchIDDestiny) {
                this.$fun.alert("El origen y el destino no pueden ser iguales", "warning");
                return;
            }
            if (!item.TransferReasonID) {
                this.$fun.alert("Seleccione el motivo de traspaso", "warning");
                return;
            }
            if (!item.TransferWeight || parseFloat(item.TransferWeight) <= 0) {
                this.$fun.alert("Ingrese un peso válido mayor a 0", "warning");
                return;
            }
            if (this.isSaving) return;

            item.SecStatus = 1;

            this.$fun.alert("¿Desea guardar el traspaso?", "question").then(async r => {
                if (r.value) {
                    this.isSaving = true;
                    try {
                        await item.save();
                    } catch (e) {
                        console.error(e);
                    } finally {
                        this.isSaving = false;
                    }
                }
            });
        },
        onAddEvent() {
            this.selectedOriginLineID = null;
            this.selectedDestinyLineID = null;
            this.originPeriods = [];
            this.destinyPeriods = [];
        },
        onRowSelected(selected) {
            const item = Array.isArray(selected) ? selected[0] : selected;
            if (item && item.IsExecuted) {
                this.isCurrentRowExecuted = true;
            } else {
                this.isCurrentRowExecuted = false;
            }
        },
        async onEditEvent(selected) {
            const item = Array.isArray(selected) ? selected[0] : selected;
            if (item && item.IsExecuted) {
                this.$fun.alert("No se puede editar un movimiento que ya fue ejecutado.", "warning");
                this.$refs.crudProductMovement.$refs.toolbar.cancel();
                return;
            }
            if (item) {
                const origPeriod = this.allPeriodsMap.find(p => p.PchID === item.PchIDOrigin);
                if (origPeriod) {
                    this.selectedOriginLineID = origPeriod.ClpID;
                    await this.onOriginLineChange(this.selectedOriginLineID, item);
                    item.PchIDOrigin = origPeriod.PchID;
                } else {
                    this.selectedOriginLineID = null;
                    this.originPeriods = [];
                }
                const destPeriod = this.allPeriodsMap.find(p => p.PchID === item.PchIDDestiny);
                if (destPeriod) {
                    this.selectedDestinyLineID = destPeriod.ClpID;
                    await this.onDestinyLineChange(this.selectedDestinyLineID, item);
                    item.PchIDDestiny = destPeriod.PchID;
                } else {
                    this.selectedDestinyLineID = null;
                    this.destinyPeriods = [];
                }
            }
        },
        deleteItem(selected) {
            const item = Array.isArray(selected) ? selected[0] : selected;
            if (!item) return;
            if (item.IsExecuted) {
                this.$fun.alert("No se puede eliminar un movimiento que ya fue ejecutado.", "warning");
                return;
            }
            this.$fun.alert("¿Seguro de Eliminar Registro?", "question").then(r => {
                if (r.value) {
                    _sFrzLinesTransferHistory.delete(item, this.$fun.getUserID()).then(resp => {
                        if (resp.status === 200) {
                            this.$fun.alert("Eliminado Correctamente", "success");
                            this.$refs.crudProductMovement.refresh();
                        }
                    }).catch(e => {
                        this.$fun.alert(e.message || "Error al eliminar el traspaso", "error");
                    });
                }
            });
        },
        executeMovement(row) {
            this.$fun.alert("¿Desea ejecutar este traspaso?", "question").then(r => {
                if (r.value) {
                    const payload = {
                        LthID: row.LthID
                    };
                    _sFrzLinesTransferHistory.execute(payload, this.$fun.getUserID()).then(resp => {
                        if (resp.status === 200) {
                            this.$fun.alert("El traspaso fue ejecutado correctamente", "success");
                            this.$refs.crudProductMovement.refresh();
                        }
                    }).catch(e => {
                        this.$fun.alert(e.message || "Error al ejecutar el traspaso", "error");
                    });
                }
            });
        }
    }
};
</script>

